import React, { useMemo, useState } from 'react';
import { Box, Button, Container, Typography, Paper, Divider } from '@mui/material';
import { useApiQuery } from '../hooks/useApiCache';
import { buildPayload, getRequestCount } from '../services/apiService';

const fixedFilters = {
  // Ajuste as datas conforme necessário para seu backend
  startDate: new Date(2025, 9, 28), // 28/10/2025
  endDate: new Date(2025, 9, 29),   // 29/10/2025
  contrato: undefined,
  centro: undefined,
  equipe: undefined
};

export default function CacheDebug() {
  const [mountKey, setMountKey] = useState(0);
  const [lastCounts, setLastCounts] = useState({ first: 0, second: 0 });

  const endpoint = '/percentual-turnos-diario';
  const payload = useMemo(() => buildPayload(fixedFilters), []);

  const { isLoading, isFetching, refetch } = useApiQuery(endpoint, fixedFilters, {
    enabled: true,
    staleTime: 5 * 60 * 1000,
  });

  const readCounts = () => getRequestCount(endpoint, payload);

  const handleMeasureOnce = () => {
    // Mede quantas chamadas foram feitas até agora
    const count = readCounts();
    setLastCounts(c => ({ ...c, first: count }));
  };

  const handleRemountAndMeasure = () => {
    // Remonta o componente (muda a key) e mede novamente
    setMountKey(k => k + 1);
    setTimeout(() => {
      const count = readCounts();
      setLastCounts(c => ({ ...c, second: count }));
    }, 300);
  };

  return (
    <Container maxWidth="md" key={mountKey}>
      <Box sx={{ my: 4 }}>
        <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>Cache Debug</Typography>
        <Paper sx={{ p: 2, mb: 2 }}>
          <Typography variant="body2">Endpoint: <b>{endpoint}</b></Typography>
          <Typography variant="body2">Payload: <code>{JSON.stringify(payload)}</code></Typography>
          <Divider sx={{ my: 2 }} />
          <Typography variant="body2">isLoading: {String(isLoading)}</Typography>
          <Typography variant="body2">isFetching: {String(isFetching)}</Typography>
          <Typography variant="body2">networkCalls (medido): {readCounts()}</Typography>
          <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
            <Button variant="contained" onClick={handleMeasureOnce}>Medir agora</Button>
            <Button variant="outlined" onClick={handleRemountAndMeasure}>Remontar e medir</Button>
            <Button variant="text" onClick={() => refetch()}>Refetch manual</Button>
          </Box>
        </Paper>
        <Paper sx={{ p: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>Resultados</Typography>
          <Typography variant="body2">Contagem após primeira medição: <b>{lastCounts.first}</b></Typography>
          <Typography variant="body2">Contagem após remontar: <b>{lastCounts.second}</b></Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            Esperado: a contagem <b>não</b> deve aumentar após remontar (cache ativo). Aumenta apenas com refetch manual ou alteração de filtros.
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
}


